// Repeat on anything that sets its own color. `text-muted-foreground` overrides it.
export const HUB_DARK_TEXT_CLASS = 'dark:text-gz-neutral-100';
